"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuantityPicker = useQuantityPicker;
var _react = require("react");
var QuantityPickerClick = _interopRequireWildcard(require("./QuantityPickerClickEvent"));
var _useControlledQuantityPicker = require("./useControlledQuantityPicker");
var _useUncontrolledQuantityPicker = require("./useUncontrolledQuantityPicker");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Use QuantityPicker - logic for QuantityPicker with increase and decrease events
 * Can be uses with controlled or uncontrolled manner
 * @param {UseQuantityPickerProps} props
 */
function useQuantityPicker(props) {
  const autoId = (0, _react.useId)();
  const {
    id = autoId,
    InputProps,
    value,
    visibilityTriggerClicked = false
  } = props;
  const [lastIncreased, setLastIncreased] = (0, _react.useState)('');
  const [loadOnClick, setLoadOnClick] = (0, _react.useState)(visibilityTriggerClicked);
  const [tooltipMaxOpen, setTooltipMaxOpen] = (0, _react.useState)(false);
  const triggerClickEvent = (0, _react.useCallback)(identifier => {
    const event = new CustomEvent(QuantityPickerClick.Name, {
      detail: {
        id: identifier
      }
    });
    window.dispatchEvent(event);
  }, []);

  /** INFO Called on clickAway to reset lastIncreased when clicking on other lickers and/or other links */
  const resetLastIncreased = (0, _react.useCallback)(source => {
    setLastIncreased('');
    setLoadOnClick(false);
  }, []);
  const handleKeyDown = (0, _react.useCallback)(({
    currentTarget,
    key
  }) => {
    if (key === 'Enter') {
      currentTarget.blur();
    }
  }, []);

  /** INFO Set last increased for newly initiated.
   * In case that the value is set to zero, on next increase will be set as newly initiated again.
   */
  (0, _react.useEffect)(() => {
    if (loadOnClick && typeof value === 'number' && value === 1) {
      setLastIncreased(id);
    }
    triggerClickEvent(id);
    setLoadOnClick(false);
  }, [id, loadOnClick, triggerClickEvent, value]);

  // INFO Memoize the event listener to avoid unnecessary re-registrations
  const onQuantityPickerClickListener = (0, _react.useCallback)(event => {
    if (event.detail.id !== id) {
      resetLastIncreased(`action on ${event.detail.id} ➡️`);
    }
  }, [id, resetLastIncreased]);
  (0, _react.useEffect)(() => {
    window.addEventListener(QuantityPickerClick.Name, onQuantityPickerClickListener);
    return () => {
      window.removeEventListener(QuantityPickerClick.Name, onQuantityPickerClickListener);
    };
  }, [onQuantityPickerClickListener]);

  // INFO Memoize innerProps to avoid unnecessary re-renders in controlled/uncontrolled hooks
  const innerProps = (0, _react.useMemo)(() => ({
    ...props,
    id,
    loadOnClick,
    setLastIncreased,
    triggerClickEvent,
    setTooltipMaxOpen
  }), [props, id, loadOnClick, setLastIncreased, triggerClickEvent, setTooltipMaxOpen]);

  // eslint-disable-next-line react/hook-use-state -- Lock controlled/uncontrolled mode on mount
  const [isControlled] = (0, _react.useState)(() => value != null);
  const controlled = (0, _useControlledQuantityPicker.useControlledQuantityPicker)(innerProps);
  const uncontrolled = (0, _useUncontrolledQuantityPicker.useUncontrolledQuantityPicker)(innerProps);
  if (isControlled) {
    return {
      ...controlled,
      InputProps: {
        ...InputProps
      },
      lastIncreased,
      tooltipMaxOpen,
      handleKeyDown,
      setTooltipMaxOpen
    };
  }
  return {
    ...uncontrolled,
    InputProps: {
      ...InputProps
    },
    lastIncreased,
    tooltipMaxOpen,
    handleKeyDown,
    setTooltipMaxOpen
  };
}
//# sourceMappingURL=useQuantityPicker.js.map